function setVh() {
  const vh = window.innerHeight / 100
  try {
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  } catch (e) {
    console.error('error setting --vh', e)
  }
}

window.addEventListener('resize', setVh)
window.addEventListener('orientationchange', setVh)
setVh()
